export default function ElectricCooler(props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M24 6V42" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 16L40 34" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 32L40 16" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.3333 12L16 20.1818L8 22" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 26L16 27.8182L13.3333 36" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M34.6667 12L32 20.1818L40 22" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M40 26L32 27.8182L34.6667 36" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 8L24 14L30 8" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 40L24 34L30 40" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
